import { render, staticRenderFns } from "./trailerDeeplink.vue?vue&type=template&id=17140de7&"
import script from "./trailerDeeplink.vue?vue&type=script&lang=js&"
export * from "./trailerDeeplink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports